import { render, staticRenderFns } from "./Personalizations.vue?vue&type=template&id=6e3b22a8"
import script from "./Personalizations.vue?vue&type=script&lang=js"
export * from "./Personalizations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports